import { useState, useEffect } from "react";
import logo from "../res/logo.png";
import { Link } from "react-router-dom";

function NavBar(props) {
  const homeClass = props.homeClass;
  const progClass = props.progClass;
  const aboutClass = props.aboutClass;
  const journalsClass = props.journalsClass;

  const [isOpen, setIsOpen] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const renderNavBarClass = () => {
    return isOpen ? "" : "hidden";
  };

  const collapseSwitch = () => {
    isOpen ? setIsOpen(false) : setIsOpen(true);
  };

  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <nav className={`w-[100vw] fixed top-0 z-10 transition-all duration-300 ease-in-out ${
      isScrolled 
        ? 'bg-gradient-to-r from-[#eaac38] to-[#c48918] dark:from-[#eaac38] dark:to-[#c48918] border-[#eaac38]/20 dark:border-[#c48918]/30 drop-shadow-md h-12'
        : 'bg-gray-100 dark:bg-gray-800 border-gray-200 dark:border-gray-700 h-24'
    }`}>
      <div className={`max-w-screen-xl flex flex-wrap items-center justify-between mx-auto transition-all duration-300 ${
        isScrolled ? 'p-3' : 'p-4'
      }`}>
        <Link to="/">
          <img src={logo} className={`h-14 mr-1 ${isScrolled ? 'hidden' : 'p-0'}`}  alt="PEACI Logo" />
          <span className={`text-xl font-bold text-white ${isScrolled ? '' : 'hidden'}`}>PEACI</span>
        </Link>
        <button
          data-collapse-toggle="navbar-default"
          type="button"
          className={`inline-flex items-center p-2 ml-3 text-sm md:hidden hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-white/30 ${
        isScrolled ? 'text-white/80' : 'text-[#eaac38]'
      } dark:text-white/70 dark:hover:bg-white/5 dark:focus:ring-white/20`}
          aria-controls="navbar-default"
          aria-expanded="false"
          onClick={collapseSwitch}
        >
          <span className="sr-only">Open main menu</span>
          <svg
            className="w-6 h-6"
            aria-hidden="true"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
              clipRule="evenodd"
            ></path>
          </svg>
        </button>
        <div
          className={`${renderNavBarClass()} w-full md:block md:w-auto transition-all transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) transition-duration: 150ms`}
          id="navbar-default"
        >
          <ul className="font-medium flex flex-col p-4 md:p-0 mt-4 border  border-amber-200/50 bg-[#eaac38] md:bg-transparent dark:border-amber-700/50 dark:bg-amber-900/50 md:flex-row md:space-x-8 md:mt-0 md:border-0 ">

            <li>
              <Link to="/" className={`${homeClass} text-gray-900 dark:text-gray-100 hover:text-amber-600 dark:hover:text-amber-400`}>
                Home
              </Link>
            </li>
            <li>
              <Link to="/programs" className={`${progClass} text-gray-900 dark:text-gray-100 hover:text-amber-600 dark:hover:text-amber-400`}>
                Programs
              </Link>
            </li>
            <li>
              <Link to="/journal" className={`${journalsClass} text-gray-900 dark:text-gray-100 hover:text-amber-600 dark:hover:text-amber-400`}>
                Journal
              </Link>
            </li>
            <li>
              <Link to="/about" className={`${aboutClass} text-gray-900 dark:text-gray-100 hover:text-amber-600 dark:hover:text-amber-400`}>
                About PEACI
              </Link>
            </li>
            <li>              
              <a href="https://my.peaci.edu.ph/" className={`${aboutClass} text-gray-900 dark:text-gray-100 hover:text-amber-600 dark:hover:text-amber-400`}>
                My.PEACI
              </a>
            </li>
          </ul>
        </div>
        
      </div>
    </nav>
  );
}

export default NavBar;
